export default __webpack_public_path__ + "static/media/Active_TP.f62d19e7.svg";